import React from 'react';
import { connect } from 'react-redux';
import Price from '../../../utils/Price';

const OthersDetail = (props) => {
    return (
      <div>
        <div className="imageHolder"><img src={props.image} alt="others img" /></div>
        <div className="textHolder">
          <div className="productName">
            {props.productName}
            <span className="price pullRight">
              <Price
                isTotal
                isTeamSport
                priceNet={props.unitNetPrice}
                currency={props.settings.currency}
              />
            </span>
          </div>
          <div className="customisationElement">
            <span className="customisationTitle">
              {props.generalTranslations.Size}
              {': '}
            </span>
            <span>{props.sizeName}</span>
          </div>
        </div>
      </div>
    );
  };

const mapState = state => (
  {
    generalTranslations: state.generalTranslations,
    settings: state.settings,
  }
);

export default connect(mapState, null)(OthersDetail);
